import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class DocumentModel extends BaseModel {
  static urlPath = "documents";

  @attr("boolean") approved;
  @attr("string") clientName;
  @attr("array") appointments;
  @attr("array") relatedProviders;
  @attr("number") associatedAppointmentCount;
  @attr("number") case;
  @attr("string") caseName;
  @attr("string") sourceLabel;
  @attr("string") documentTypeLabel;
  @attr("boolean") checked;
  @attr("number") checkedBy;
  @attr("string") checkedByName;
  @attr("datetime") createdAt;
  @attr("number") createdBy;
  @attr("string") createdByName;
  @attr("number") documentType;
  @attr("string") file;
  @attr("string") fileName;
  @attr("boolean") policeReportReceived;
  @attr("number") provider;
  @attr("string") providerName;
  @attr("number") providerTotalAppointmentCount;
  @attr("number") referralFrom;
  @attr("string") referralFromName;
  @attr("number") referralTo;
  @attr("string") referralToName;
  @attr("number") source;
  @attr("datetime") updatedAt;
  @attr("number") updatedBy;
  @attr("string") updatedByName;
  @attr("number") pk;
  @attr("string") form;
}
